// src/services/authService.js

import apiClient from "./apiClient";

// Use centralized API client for consistent error handling
const api = apiClient;

// register with username, email, password only
export const register = async (username, email, password, inviteToken) => {
  const response = await api.post("/api/auth/register", {
    username,
    email,
    password,
    inviteToken,
  });
  return response.data;
};

// changed: add rememberMe param
export const login = async (email, password, rememberMe = false) => {
  const response = await api.post("/api/auth/login", {
    email,
    password,
    rememberMe,
  });
  return response.data;
};

export const getCurrentUser = async () => {
  const response = await api.get("/api/auth/me");
  return response.data;
};

export const logout = async () => {
  const response = await api.get("/api/auth/logout");
  return response.data;
};

export const forgotPassword = async (email) => {
    const response = await api.post("/api/auth/forgot-password", { email });
    return response.data; // { message: "Reset email sent. Check your inbox." }
  };
  
  export const resetPassword = async (token, email, newPassword) => {
    const response = await api.post("/api/auth/reset-password", {
      token,
      email,
      newPassword,
    });
    return response.data; // { message: "Password reset successfully" }
  };

// Multi-organization support
export const switchOrganization = async (organizationId) => {
  const response = await api.post("/api/auth/switch-organization", {
    organizationId,
  });
  return response.data;
};

export const getUserOrganizations = async () => {
  const response = await api.get("/api/auth/organizations");
  return response.data.organizations || [];
};